import * as React from 'react';

import styles from './ReportsListItem.less';
import ChartContainer from 'src/js/containers/chart/components/ChartContainer';
import {GridReducerInjector} from 'src/js/containers/grid/components/GridReducerInjector';
import PropsDataGridContainer from 'src/js/containers/grid/components/PropsDataGridContainer';
import {
  REPORT_TYPE_TABLE,
  REPORT_TYPE_CHART,
  ChartReportConfig,
  ReportConfig,
} from 'src/js/model/reports_config';

interface OwnProps {
  reportConfig: ReportConfig | ChartReportConfig | undefined;
  reportId: string;
  data: Record<string, any>;
}

type Props = OwnProps;

export const ReportsListItem: React.FC<Props> = (props) => {
  const {reportConfig, reportId, data} = props;

  let renderedReport;
  switch (reportConfig?.getType()) {
    case REPORT_TYPE_CHART: {
      renderedReport = (
        <ChartContainer
          reportData={data}
          chartId={reportConfig?.getId()}
          propsChartConfigModel={reportConfig}
        />
      );
      break;
    }
    case REPORT_TYPE_TABLE: {
      const gridConfig = reportConfig.getOptions().getTableConfig();
      renderedReport = reportConfig ? (
        <GridReducerInjector gridId={reportConfig?.getId()}>
          <PropsDataGridContainer
            gridId={reportConfig?.getId()}
            propsGridConfigModel={gridConfig}
            rowsData={data}
            disablePagination={!gridConfig.getDataGridOptions().pagination}
            autoPageSize
          />
        </GridReducerInjector>
      ) : null;
      break;
    }

    default:
      renderedReport = <span>UNKNOWN REPORT TYPE</span>;
  }
  return (
    <div
      className={styles.dlReportsListItem}
      data-name={`${reportId}-${reportConfig?.getId()}`}
    >
      {renderedReport}
    </div>
  );
};

ReportsListItem.displayName = 'ReportsListItem';
